


















































































/* eslint-disable max-len */
import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import * as amplitude from 'amplitude-js';
import services from '@/services';
import {
  VirtualLookDTO, SearchParamsDTO, VirtualLookRequestDTOSeasonsEnum,
} from '@/api';
import { clientsModule } from '@/store';
import EditingLayout from '@/layouts/EditingLayout.vue';
import LookDynamicCard from '@/components/looks/LookDynamicCard.vue';
import IconArrowLeft from '@/assets/icons/arrow-left.svg';
import IconAddComment from '@/assets/icons/add-comment.svg';
import IconFilter from '@/assets/icons/filters.svg';
import { throwError } from '@/utils';
import { Groups } from '@/utils/looks.utils';
import AiParams from '@/components/ai/AiParams.vue';

type Param = { type: string; id: string };

@Component({
  name: 'ai-looks-catalog-things-page',
  components: {
    EditingLayout, LookDynamicCard, IconArrowLeft, IconAddComment, IconFilter, AiParams,
  },
})
export default class AiLooksCatalogThingsPage extends Vue {
  looks: VirtualLookDTO[] = [];

  loading = false;

  openParams = false;

  searchParams: null | SearchParamsDTO = null;

  form = {
    score: 1,
    comment: '',
  }

  created() {
    services.aiApi().aiEndpointSearchParams()
      .then((data) => {
        this.searchParams = data.data;
      });
    this.fetchLooks();
    amplitude.getInstance().logEvent('Открыта страница аи луков из вещей каталога');
  }

  async fetchLooks() {
    // eslint-disable-next-line no-nested-ternary
    const toArray = (value?: string | (string | null)[]) => (Array.isArray(value)
      ? value
      : (value ? [value] : undefined));
    try {
      this.loading = true;
      if (this.$route.name === 'ai-looks-by-client-thing-from-catalog-things' && this.$route.params.thingId) {
        const { data: looks } = await services.aiApi().aiEndpointCatalogThingsLooks({
          clientThingIds: [Number(this.$route.params.thingId)],
          style: toArray(this.$route.query.styles) as Array<string>,
          // sizes: toArray(this.$route.query.sizes) as Array<string>,
          prices: toArray(this.$route.query.prices) as Array<string>,
          seasons: toArray(this.$route.query.seasons) as Array<VirtualLookRequestDTOSeasonsEnum>,
        });
        this.looks = looks;
      }
      if (this.$route.name === 'ai-looks-by-catalog-thing-from-catalog-things' && this.$route.params.itemId) {
        const { data: looks } = await services.aiApi().aiEndpointCatalogThingsLooks({
          catalogItemIds: [Number(this.$route.params.itemId)],
          style: toArray(this.$route.query.styles) as Array<string>,
          // sizes: toArray(this.$route.query.sizes) as Array<string>,
          prices: toArray(this.$route.query.prices as string[]) as Array<string>,
          seasons: toArray(this.$route.query.seasons as string[]) as Array<VirtualLookRequestDTOSeasonsEnum>,
        });
        this.looks = looks;
      }
    } catch (e) {
      throwError('Ошибка загрузки луков');
    } finally {
      this.loading = false;
    }
  }

  get groupedLooks() {
    return this.looks.map((look) => {
      const groups: Groups = {
        top2: [],
        bottom: [],
        top1: [],
        outerwear: [],
        dress: [],
        shoes: [],
        accessories: [],
        bag: [],
        jewelry: [],
      };
      (look.items || []).forEach((item) => {
        const key = item.aiType as keyof typeof groups | undefined;
        if (!key) return;
        groups[key].push(item);
      });
      return {
        ...look,
        groups,
      };
    });
  }

  get aiParams() {
    if (this.searchParams) {
      return [{
        name: 'Стиль',
        type: 'style',
        options: this.searchParams.styles || [],
      }, {
        name: 'Ценовой диапазон',
        type: 'prices',
        options: this.searchParams.prices || [],
      }, {
        name: 'Погода',
        type: 'seasons',
        options: this.searchParams.seasons || [],
      }];
    }
    return [];
  }

  get params() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { selected, ...params } = this.$route.query;
    // console.log('params', params);
    return Object.entries(params).flatMap((param) => {
      const [type, ids] = param;
      if (ids) {
        return (Array.isArray(ids) ? ids : [ids])
          .reduce<Param[]>((arr, id) => (id ? arr.concat({ type, id }) : arr), []);
      }
      return [];
    });
  }

  get selected() {
    return Number(this.$route.query.selected);
  }

  get selectedLook() {
    return this.groupedLooks.find(look => look.id === this.selected);
  }

  @Watch('selectedLook')
  updateForm(value: VirtualLookDTO) {
    this.form.score = value.userScore || 1;
    this.form.comment = value.comment || '';
  }

  get count() {
    return this.looks.length;
  }

  get options() {
    return this.$route?.meta?.options;
  }

  get client() {
    return clientsModule.model;
  }

  setSelected(id: number) {
    this.$router.push({ query: { selected: String(id) } });
  }

  setParams(params: Param[]) {
    const query = params.reduce<Record<string, string[]>>((obj, param) => ({
      ...obj,
      [param.type]: obj[param.type] ? obj[param.type].concat(param.id) : [param.id],
    }), {});
    const { selected } = this.$route.query;
    this.$router.push({ query: { ...query, selected } });
    this.fetchLooks();
  }

  getTitle(param: Param) {
    const category = this.aiParams.find(c => c.type === param.type);
    const option = category?.options.find(o => o.id === param.id);
    return option ? option.name : 'Error';
  }

  addLookToSandbox() {
    if (this.client?.id != null && this.selectedLook && this.selectedLook.id != null) {
      services.sandboxApi().sandboxEndpointAddVirtualLook(this.client.id, this.selectedLook.id)
        .then(() => {
          this.$notify({ type: 'success', title: 'Образ добавлен', message: 'Образ добавлен в песочницу' });
        });
    }
  }

  commentVirtualLook() {
    services.aiApi().aiEndpointCommentVirtualLook(this.selected, this.form.score, this.form.comment);
  }

  back() {
    this.$router.push({ name: this.options.back });
  }
}

